import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    miniSettingsContainer: {
        position: 'absolute',
        top: '10px',
        display: 'flex',
        zIndex: 100,
        fontSize: '11px'
    },
    miniSettingsMenuItem: {
        display: 'flex',
        minWidth: '40px',
        textAlign: 'center',
        justifyContent: 'center'
    }
}))

export default useStyles